// useWarningOnExit customHook

import { useCountriesStore } from "@multicines/stores";
import Router from "next/router";
import { useRouter } from "next/router";
import { useRef, useEffect } from "react";

import { useStoresStore } from "stores/stores/stores.store";
import { BasicInternationalization } from "types/common.types";

const useWarningOnExit = (
  shouldWarn: boolean,
  t: BasicInternationalization,
  callback: () => void,
  isTalkShop?: boolean
) => {
  const router = useRouter();
  const message = t.common.warning;
  const lastHistoryState = useRef(global.history?.state);
  const selectedStore = useStoresStore(store => store.selectedStore);
  const selectedCity = useCountriesStore(state => state.selectedCity);

  useEffect(() => {
    const storeLastHistoryState = () => {
      lastHistoryState.current = window?.history.state;
    };
    Router.events.on("routeChangeComplete", storeLastHistoryState);
    return () => {
      Router.events.off("routeChangeComplete", storeLastHistoryState);
    };
  }, []);

  useEffect(() => {
    let isWarned = false;

    const routeChangeStart = (url: any) => {
      if (Router.asPath !== url && shouldWarn && !isWarned) {
        const newUrl = isTalkShop
          ? `${url}?cityId=${selectedCity?.id}&storeId=${selectedStore?.[0]?.storeId}`
          : url;
        isWarned = true;
        if (window.confirm(message)) {
          callback();
          router.push(newUrl);
        } else {
          isWarned = false;
          Router.events.emit("routeChangeError");

          // eslint-disable-next-line no-throw-literal
          throw "Abort route change. Please ignore this error.";
        }
      }
    };

    const beforeUnload = (e: any) => {
      if (shouldWarn && !isWarned) {
        const event = e || window.event;
        event.returnValue = message;
        return message;
      }
      return null;
    };

    Router.events.on("routeChangeStart", routeChangeStart);
    window.addEventListener("beforeunload", beforeUnload);

    return () => {
      Router.events.off("routeChangeStart", routeChangeStart);
      window.removeEventListener("beforeunload", beforeUnload);
    };
  }, [
    callback,
    isTalkShop,
    message,
    router,
    selectedCity,
    selectedStore,
    shouldWarn
  ]);
};

export default useWarningOnExit;
